import { useMemo } from "react";
import { useLocation } from "react-router";

export function useGetURLQuery(errorHandler: (e: Error) => void, string: string): string;

export function useGetURLQuery<ParamType>(errorHandler: (e: Error) => void): ParamType;

export function useGetURLQuery<ParamType>(errorHandler?: (e: Error) => void, string?: string) {
  const url = useLocation().search;
  let queries = new URLSearchParams(url);

  try {
    const decodedQueries = decodeURIComponent(url);
    queries = new URLSearchParams(decodedQueries);
  } catch (error) {
    if (errorHandler && error instanceof Error) errorHandler(error);
  }

  if (string) {
    if (string.includes(",")) {
      const queryArray = string.split(", ");
      return queryArray.map((query: string) => queries.get(query));
    }
    return queries.get(string);
  }


  const params = useMemo(() => {
    const urlParams = <ParamType>{};
    queries.forEach((value: string | number, key: string) => {
      Object.defineProperty(urlParams, key, {
        value,
        enumerable: true,
      });
    });
    return urlParams;
  }, [url]);

  return params;
}
